import React, { useEffect, useRef, useState } from "react";

export default function LazyImage({
  src,
  alt = "",
  placeholder = "",
  className = "",
  style = {},
  onError,
  onLoad,
}) {
  const imgRef = useRef();
  const [isVisible, setIsVisible] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let observer;

    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setIsVisible(true);
              obs.unobserve(entry.target);
            }
          });
        },
        {
          rootMargin: "100px",
          threshold: 0.1,
        }
      );
      if (imgRef.current) {
        observer.observe(imgRef.current);
      }
    } else {
      setIsVisible(true);
    }

    return () => {
      if (observer && observer.disconnect) observer.disconnect();
    };
  }, []);

  const handleLoad = (e) => {
    onLoad?.(e);
  };

  const handleError = (e) => {
    setHasError(true);
    onError?.(e);
  };

  return (
    <img
      ref={imgRef}
      src={isVisible && !hasError ? src : undefined}
      alt={alt}
      className={className}
      style={style}
      onLoad={handleLoad}
      onError={handleError}
      loading="lazy"
    />
  );
}
